import React from 'react';
import './HomePage.css'; // Vamos criar esse arquivo em breve para adicionar estilos
import logoClube from './assets/clube-logo.png';
import appleStore from './assets/apple-store.png';
import googlePlay from './assets/google-play.png';

const HomePage = () => {
    return (
        <div className="container">
            <div className="header"></div>
            <div className="content">
                <img className="logo" src={ logoClube } alt="logo" /> {/* Adicione o caminho para sua logo */ }
                <div className='h1-container'>
                    <h1>Baixe agora mesmo o superApp para <b>Android</b> ou <b>iOS</b></h1>
                </div>
                <div className='p-container'>
                    <p>A ferramenta que vai te acompanhar a todo momento, auxiliar no controle da sua vida financeira e gerar milhões de experiências únicas.</p>
                </div>
                <a href="https://apps.apple.com/br/app/clube-certo-plus/id1662239139" target="_blank" rel="noreferrer">
                    <img className="apple-store" src={ appleStore } alt="App Store" /> {/* Adicione o caminho para sua imagem */ }
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.devusama.clubecerto" target="_blank" rel="noreferrer">
                    <img className="google-play" src={ googlePlay } alt="Google Play" /> {/* Adicione o caminho para sua imagem */ }
                </a>
            </div>
            <div className="divider"></div>
            <div className="footer">
                <p>@2023 - Todos os direitos reservados a Clube Certo</p>
            </div>
        </div>
    );
};

export default HomePage;
